import styled from "styled-components"

const FlexRow = styled.div`
  display: flex;
`

export default FlexRow
